<mapfre-modal
  [modalOptions]="uploadingFiles"
  [hideModal]="hideModal"
  (closeModal)="resetHideModal($event)"
>
  <div class="modal-body mt-4" [ngClass]="{'ma-update-email-modal': !isAcmic}">
    <div class="uploading-files margin-top text-center">
      <div class="inner-block">
        <h1 class="title-copy mt-4 ml-auto mr-auto">
          {{ "Please review" | translate }}
        </h1>
        <p class="mt-4 para second ml-auto mr-auto">
          Are you sure you want to update the email <strong>{{ emailMask }}</strong> as your new
          account email?
        </p>
        <p class="para ml-auto mr-auto">
          {{
            "This email will be assigned to all the policies and login credentials for your account. "
              | translate
          }}
        </p>
        <ng-container *ngIf="isAcmic; else maButtons">
          <section class="review-btns">
            <mapfre-button
              (click)="cancel()"
              additionalClasses="ghost small-btn secondary mapfre mt-4 h40 no-padding"
            >
              {{ "Cancel" | translate }}
            </mapfre-button>
            <mapfre-button
              [ngClass]="{ custom_loader: loader }"
              [disabledValue]="!loader"
              (click)="updateEmail()"
              additionalClasses="basic small-btn primary mt-4 h40 margin-bottom"
            >
              {{ "Update Email" | translate }}
            </mapfre-button>
          </section>
        </ng-container>
        <ng-template #maButtons>
          <hr class="ma-hr-tag">
          <section class="show-btn-order">
            <mapfre-button
              (click)="cancel()"
              additionalClasses="ghost small-btn secondary modal-small-btn"
            >
              {{ "Cancel" | translate }}
            </mapfre-button>
            <mapfre-button
              [ngClass]="{ custom_loader: loader }"
              [disabledValue]="!loader"
              (click)="updateEmail()"
              additionalClasses="basic small-btn primary modal-small-btn"
            >
              {{ "Update email" | translate }}
            </mapfre-button>
          </section>

        </ng-template>        
      </div>
    </div>
  </div>
</mapfre-modal>
